import { ChargeCenterLayout } from '@/modules/charge-center/components/charge-center-layout';
import { chargeCenterRoute } from '@/modules/charge-center/route';
import { createRoute } from '@tanstack/react-router';

export const chargeCenterMonitorLayoutRoute = createRoute({
  getParentRoute: () => chargeCenterRoute,
  id: '_monitor-layout',
  component: ChargeCenterLayout,
});
